import { html, ViewTemplate, when } from '@microsoft/fast-element';
import type { SideMenu } from './side-menu';
import { structuredChatIcon, userIcon } from '../../../styles';
import { PROFILE_RIGHTS } from '../../../utils';

export const SideMenuTemplate: ViewTemplate<SideMenu> = html`
  <div class="side-menu">
    <zero-button
      appearance="side-bar"
      style="display: ${(x) => (x.isUserModalOpened ? 'none' : '')}"
      @click=${(x) => x.openUserModal()}
    >
      ${userIcon('start', null, null, null)}
    </zero-button>

    <zero-button
      appearance="side-bar"
      style="display: ${(x) => (x.isUserModalOpened ? '' : 'none')}"
      @click=${(x) => x.openUserModal()}
    >
      ${userIcon('start', null, null, 'green')}
    </zero-button>

    ${when(
      (x) => x.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.STRUCTURED_CHAT_VIEW),
      html`
        <zero-button appearance="side-bar" @click=${(x) => x.openStructuredChat()}>
          ${structuredChatIcon}
        </zero-button>
      `,
    )}
    <zero-button
      ?hidden=${(x) => !x.navigationService.isKnowledgeBlockContentReady()}
      style="width: 36px"
      appearance="side-bar"
      @click=${(x) => x.openKnowledgeBlockModal()}
    >
      <zero-icon variant="solid" size="xl" name="circle-question"></zero-icon>
    </zero-button>
  </div>
`;
